/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { ToastContainer, toast } from 'react-toastify';
 import 'react-toastify/dist/ReactToastify.css';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col
} from "reactstrap";
import axios from 'axios';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      email:'',
      password:'',
      user:{},
      user_role:''
    };
    // This binding is necessary to make `this` work in the callback
    this.loginBtnClick = this.loginBtnClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.attemptLogin = this.attemptLogin.bind(this);
  }

  componentDidMount(){
    this.attemptLogin();

  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }
    
  handleChange(event){
    const target = event.target;
    const value =  target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  attemptLogin(){
    // //console.log('attempting login');
   let is_logged_in = false;
    let cur = this;
        axios({
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            method: 'get',
            url: 'https://markerportalbackend.thinkdigitalacademy.org/api/user',
        }).then(res => {           
            is_logged_in = true;
            localStorage.setItem('isLoggedIn',true);
            localStorage.setItem('userRole',res.data.user.roles[0].name);
            localStorage.setItem('user_id',res.data.user.id);
            this.setState({user:res.data.user,user_role:res.data.user.roles[0].name})
            this.props.history.push('/admin/index');
        }).catch(error => {
            let error_result = error.response;
            // //console.log(error_result);
            is_logged_in = false
        });

  }

  loginBtnClick(e){
    e.preventDefault();  
    localStorage.setItem('isLoggedIn',false);  
    const data = {
      email: this.state.email,
      password: this.state.password
    };

    axios({
      headers: { 
        'content-type': 'application/json'
    },
      method: 'post',
      url: 'https://markerportalbackend.thinkdigitalacademy.org/api/login',
      data: data
    }).then(res => {
      // //console.log(res);
      // //console.log(res.data);
      localStorage.setItem('access_token',res.data.access_token);
      localStorage.setItem('full_name',res.data.user.name+' '+res.data.user.surname);
      localStorage.setItem('user_id',res.data.user.id);
      localStorage.setItem('isLoggedIn',true);
      localStorage.setItem('userRole',res.data.user.roles[0].name);
      this.props.history.push('/admin/index');
      
    }).catch(error =>{
      let error_result = error.response;
      // //console.log("rerro",error);
      toast('Invalid Credentials, please try again', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: toast.TYPE.ERROR
    });
    });            
    // 
  }

  render() {
    return (
      <>
      <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          />
      <ToastContainer />
        <Col lg="5" md="7">
          <Card className="bg-secondary shadow border-0">
            <CardHeader className="bg-transparent pb-5">
              <div className="btn-wrapper text-center">
                <img width={140}
                    alt="..."
                    src="https://think-digital-production.s3-eu-west-1.amazonaws.com/uploads/application-images/logo_shrinking.png"
                />
              </div>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-5">

              <Form role="form">
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-email-83" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input name="email" placeholder="Email" type="email" value={this.state.email}  onChange={this.handleChange} autoComplete="new-email"/>
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input name="password" placeholder="Password" type="password" value={this.state.password}  onChange={this.handleChange} autoComplete="new-password"/>
                  </InputGroup>
                </FormGroup>
                <div className="custom-control custom-control-alternative custom-checkbox">
                  <input
                    className="custom-control-input"
                    id=" customCheckLogin"
                    type="checkbox"
                  />
                  <label
                    className="custom-control-label"
                    htmlFor=" customCheckLogin"
                  >
                    <span className="text-muted">Remember me</span>
                  </label>
                </div>
                <div className="text-center">
                  <Button className="my-4" disabled={!this.validateForm()} color="info" type="button" onClick={this.loginBtnClick}>
                    Sign in
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>

        </Col>
      </>
    );
  }
}

export default Login;
